<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="700px"
    :before-close="close"
    title="修改个人信息"
  >
    <el-form :model="initForm" :rules="rules" ref="form">
      <el-form-item label="用户名" prop="username" label-width="160px">
        <el-input v-model="initForm.username"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email" label-width="160px">
        <el-input v-model="initForm.email"></el-input>
      </el-form-item>
      <el-form-item label="姓名" label-width="160px">
        <el-input v-model="initForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号" label-width="160px">
        <el-input v-model="initForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="部门" label-width="160px">
        <el-select v-model="initForm.department" placeholder="请选择">
          <el-option
            style="font-size:16px;"
            v-for="department in departmentGroup"
            :label="department.Name"
            :key="department.ID"
            :value="department.ID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      dialogFormVisible: true,
      initForm: {
        username: "",
        email: "",
        mobile: "",
        department: 0
      },
      step: 1,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        department: [{ required: true, message: "请选择部门", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.initForm.username = localStorage.getItem("username");
    this.initForm.email = localStorage.getItem("email");
    this.initForm.mobile = localStorage.getItem("mobile");
    if (!isNaN(localStorage.getItem("department"))) {
      this.initForm.department = parseInt(localStorage.getItem("department"));
    } else {
      this.initForm.department = null;
    }
  },
  computed: {
    departmentGroup() {
      let departmentGroup = this.$store.state.departmentGroup;
      return departmentGroup;
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        let form = Object.assign({}, this.initForm);
        let methods = "put";
        let url = "account/" + localStorage.getItem("id") + "/";

        this.$http[methods](url, form, data => {
          this.$http.get(url, {}, data => {
            localStorage.setItem("department", data.data.department);
            localStorage.setItem("email", data.data.email);
            localStorage.setItem("is_admin", data.data.is_admin);
            localStorage.setItem("mobile", data.data.mobile);
            localStorage.setItem("username", data.data.username);
          });

          this.$baseNotice.message(data.msg);
          this.$emit("close");
        });
      });
    }
  }
};
</script>
